import BlockObserver from "./BlockObserver";

export default class Search {
    constructor(el) {
		let searchTimer;
		el.addEventListener('click', (e) => {
			e.preventDefault();
			document.querySelector('.part-search').classList.toggle('part-search--visible');
		});

		document.querySelector('.part-search').addEventListener('click', function(e) {
			if (!document.querySelector('.part-search .form-group').contains(e.target)) {
				document.querySelector('.part-search').classList.remove('part-search--visible');
			}
		})

		document.querySelector('[clearsearch]').addEventListener('click', (e) => {
			document.querySelector('.part-search input').value = "";
			document.querySelector('[clearsearch]').style.opacity = 0;
			document.querySelector('.part-search__results').innerHTML = '';
		});

		document.querySelector('.part-search input').addEventListener('keyup', (e) => {
			clearTimeout(searchTimer);
			document.querySelector('[clearsearch]').style.opacity = 0;
			if(document.querySelector('.part-search input').value) {
				document.querySelector('[clearsearch]').style.opacity = 1;
				searchTimer = setTimeout(this.loadResults, 250);
			} else {
				document.querySelector('.part-search__results').innerHTML = '';
			}
		});
    }

	loadResults() {
		this.filters		= new FormData();
		this.filters.append('term', document.querySelector('.part-search input').value);

		fetch('/wp-admin/admin-ajax.php?action=loadSearch', {
			method: 'POST',
			body: this.filters,
		})
		.then(response => response.json())
		.then(data => {
			if(data['results']) {
				document.querySelector('.part-search__results').innerHTML = '';
				data['results'].forEach((result) => {
					document.querySelector('.part-search__results').insertAdjacentHTML('beforeend', result);
				});
			} else {
				document.querySelector('.part-search__results').innerHTML = '';
				document.querySelector('.part-search__results').insertAdjacentHTML('beforeend', data);

			}
			return data;
		})
	}
}